exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .piKEHXL3RavO9QDprQ3it{padding-bottom:0!important}.piKEHXL3RavO9QDprQ3it .ms-BasePicker-input{height:26px!important}.piKEHXL3RavO9QDprQ3it .ms-BasePicker-text{min-height:unset!important}", ""]);
// Exports
exports.locals = {
	"smallWellWrapperOverride": "piKEHXL3RavO9QDprQ3it"
};